import React, { useState, useEffect } from "react";
import renewal from "../../assets/svg/renewal.svg";
import commission from "../../assets/svg/commission.svg";
import premium from "../../assets/svg/premium.svg";
import { makeStyles } from "@mui/styles";
import { getRenewals } from "../../services/ChartService";
import { pushNotification } from "../../redux/actions";
import CONSTANTS, { Chart_Errors } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import NoData from "./NoData";
import Colors from "../../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  upcomingRenewalsContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  headerText: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 600,
  },
  cardsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "80%",
  },
  cardsSubContainer: {
    background: Colors.RENEWAL_CARD_BG,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
    alignItems: "center",
    borderRadius: "10px",
    width: "30%",
    height: "70%",
  },
  cardTextConatiner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  footerText: {
    display: "flex",
    justifyContent: "center",
    color: Colors.RENEWAL_FOOTER_TEXT_COLOR,
    fontSize: theme.fontSizes.SMALL,
  },
  containerValue: {
    fontWeight: 600,
    fontSize: theme.fontSizes.SMALL,
  },
  cardsLabel: {
    // fontWeight: 500,
    fontSize: theme.fontSizes.SMALL,
  },
}));

const UpcomingRenewals = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [chartData, setChartData] = useState([
    {
      icon: renewal,
      value: 0,
      label: "Renewals",
    },
    {
      icon: premium,
      value: 0,
      label: "Premium",
    },
    {
      icon: commission,
      value: 0,
      label: "Commission",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetRenewals = async () => {
    setIsLoading(true);
    const response: any = await getRenewals();
    if (response?.success) {
      setChartData([
        {
          icon: renewal,
          value: response?.data?.totalRenewals,
          label: "Renewals",
        },
        {
          icon: premium,
          value: response?.data?.totalNetPremium,
          label: "Premium",
        },
        {
          icon: commission,
          value: response?.data?.totalNetCommissionAmount,
          label: "Commission",
        },
      ]);
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.SUCCESS,
      //   })
      // );
    } else {
      setChartData([]);
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.ERROR,
      //   })
      // );
    }
  };

  useEffect(() => {
    handleGetRenewals();
  }, []);

  return (
    <div className={classes.upcomingRenewalsContainer}>
      <div className={classes.headerText}>Upcoming Renewals</div>
      {chartData?.length > 0 && !isLoading && (
        <>
          <div className={classes.cardsContainer}>
            {chartData &&
              chartData?.map((item, index) => {
                return (
                  <div className={classes.cardsSubContainer}>
                    <div>
                      <img src={item?.icon} alt={item?.label} />
                    </div>
                    <div className={classes.cardTextConatiner}>
                      <div className={classes.containerValue}>
                        {item?.value}

                        {/* {item?.label !== "Renewals" && "Cr"} */}
                      </div>
                      <div className={classes.cardsLabel}>{item?.label}</div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className={classes.footerText}>
            * The upcoming renewals are for the next 45 days.
          </div>
        </>
      )}

      {chartData?.length === 0 && !isLoading && (
        <NoData errorLabel={Chart_Errors.renewals_error} />
      )}
    </div>
  );
};

export default UpcomingRenewals;
